import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import Counter from './counter';

/**
 * Rest of the code remains the same
 */
const Line_chart = ({ data, Yaxis_name }) => {

    //stroke and grid
    const chart_stroke_color = "#D2D5DB"; //the X and Y axis line color - grey300
    const chart_grid_color = "#D2D5DB"; //color of the grid - grey300

    //text
    const chart_text_color = "#6B7280";
    const chart_font_color = "#6E68C1";
    const chart_font_size = 10;
    const chart_font_weight = "500";

    //axis
    const axisLineX = false;
    const axisLineY = false;

    const axisTickLineX = true;
    const axisTickLineY = false;

    //tooltip
    const tooltip_font_size = 12;
    const tooltip_font_weight = "800";
    const tooltip_background_color = "#FFFFFF";
    const tooltip_border_color = "#E5E7EB";
    const tooltip_border_radius = "5px";

    //the Line (value line )
    const line_stroke_color = "#6E67C0";
    const line_stroke_width = 2;



    return (



        <div className="chart-card">


            <ResponsiveContainer height={250}>

                <LineChart data={data} className="custom-linechart" >

                    <CartesianGrid horizontal={true} vertical={false} stroke={chart_grid_color} />    {/*  This is the grid that appears in the background of the chart. We customize it to have a dashed line and a light gray color  */}

                    <XAxis dataKey="x" tick={{ fontSize: chart_font_size, fill: chart_text_color, fontWeight: chart_font_weight }} tickLine={axisTickLineX ? { stroke: chart_stroke_color } : false} axisLine={axisLineX ? { stroke: chart_grid_color } : false} allowDataOverflow={false} />  {/*  This is the x-axis of the chart. We customize it   to have a light gray color and no tick lines */}

                    <YAxis width={35} tick={{ fontSize: chart_font_size, fill: chart_text_color, fontWeight: chart_font_weight }} tickLine={axisTickLineY ? { stroke: chart_stroke_color } : false} axisLine={axisLineY ? { stroke: chart_grid_color } : false} />  {/*  This is the y-axis of the chart. We customize it to have a light gray color, hide the axis line, and keep the tick lines and text. We also set the width of the axis to 35 pixels */}

                    <Tooltip
                        contentStyle={{
                            margin: '0',
                            fontSize: tooltip_font_size,
                            fontWeight: tooltip_font_weight,
                            backgroundColor: tooltip_background_color,
                            border: `1px solid ${tooltip_border_color}`,
                            borderRadius: tooltip_border_radius
                        }}
                    />    {/*  This is the tooltip that appears when the user hovers over a data point. We customize it to  have a light gray background and white text with rounded corners (border radius of 5px)*/}

                    <Line
                        className="custom-line"
                        type="monotone"
                        dataKey="y"
                        name={Yaxis_name}
                        stroke={line_stroke_color}  // Apply custom stroke color
                        strokeWidth="var(--chart_stroke_width)" // Apply custom stroke width
                        activeDot={{ className: 'custom-line-active-dot' }}
                        dot={{ className: 'custom-line-dot' }}
                        isAnimationActive={false}
                    />

                    <Line
                        type="monotone"
                        dataKey="z"
                        stroke={"#FF0000"}
                        strokeWidth={1}
                        dot={false}
                        activeDot={false}
                        name="slope"
                    />

                </LineChart>

            </ResponsiveContainer>


        </div>



    );
}

export default Line_chart;